@if (
  kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.No ||
  kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.Maybe ||
  kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.NotSet
  ) {
  <div
    class="orange icon-with-text"
    >
    <mat-icon svgIcon="obs-solid"></mat-icon>
    <span>Kunden er ikke kreditværdig!</span>
    <br />
    <span>
      <em>{{ kreditvurdering?.aarsagTekst }}</em>
    </span>
  </div>
}
@if (!kreditvurdering) {
  <div class="orange icon-with-text">
    <mat-icon svgIcon="obs-solid"></mat-icon>
    Kreditcheck kunne ikke gennemføres.
  </div>
}
<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Opret eftersyn</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <div class="service service--create">
    <form [formGroup]="form" [attr.autocomplete]="'off'">
      <div class="form-row">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Ønsket deadline</mat-label>
          <input #input matInput [matDatepicker]="picker" formControlName="deadline" [min]="minDeadlineDate" />
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        @if (partnerEndateSoon) {
          <span>Bemærk: Partneren er opsagt indenfor 60 dage</span>
        }
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="mdc-textarea-fix">
          <mat-label>Beskrivelse til serviceordre {{ validationErrors }}</mat-label>
          @if (validationErrors.length !== 0) {
            <textarea formControlName="note" matInput rows="2"></textarea>
          }
          @if (validationErrors.length == 0) {
            <textarea formControlName="note" matInput rows="5"></textarea>
          }
          <mat-hint align="end">
            <app-character-count [control]="note" [maxlength]="500"></app-character-count>
          </mat-hint>
          @if (note.hasError('maxlength')) {
            <mat-error>Beskrivelse til serviceordre må højest være 500 karakterer lang</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="mdc-textarea-fix">
          <mat-label>Fast note til s-partner/tekniker</mat-label>
          @if (validationErrors.length !== 0) {
            <textarea formControlName="fastOrdreNote" matInput rows="2"></textarea>
          }
          @if (validationErrors.length == 0) {
            <textarea formControlName="fastOrdreNote" matInput rows="3"></textarea>
          }
          <mat-hint align="end">
            <app-character-count [control]="fastOrdreNote" [maxlength]="500"></app-character-count>
          </mat-hint>
          @if (note.hasError('maxlength')) {
            <mat-error>Fast note til s-partner/tekniker må højest være 500 karakterer lang.</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="mdc-textarea-fix">
          <mat-label>Fakturanote</mat-label>
          @if (validationErrors.length !== 0) {
            <textarea formControlName="fakturaNote" matInput rows="2"></textarea>
          }
          @if (validationErrors.length == 0) {
            <textarea formControlName="fakturaNote" matInput rows="3"></textarea>
          }
          <mat-hint align="end">
            <app-character-count [control]="fakturaNote" [maxlength]="500"></app-character-count>
          </mat-hint>
          @if (note.hasError('maxlength')) {
            <mat-error>Fakturanote må højest være 500 karakterer lang.</mat-error>
          }
        </mat-form-field>
      </div>
      @if (kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.Maybe || kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.NotSet) {
        <div
          class="form-row"
          >
          <mat-checkbox formControlName="accept">Jeg er opmærksom på at kunden ikke er kreditværdig.</mat-checkbox>
        </div>
      }

      @if (kreditvurdering?.kreditvaerdig === kreditvaerdigEnum.Maybe) {
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Bemærkning</mat-label>
            <input formControlName="acceptTekst" matInput maxlength="32" />
            <mat-hint align="end">
              <app-character-count [control]="acceptTekst" [maxlength]="32"></app-character-count>
            </mat-hint>
            @if (acceptTekst.hasError('maxlength')) {
              <mat-error>Fakturanote må højest være 32 karakterer lang.</mat-error>
            }
          </mat-form-field>
        </div>
      }
    </form>
    @for (error of validationErrors; track error) {
      <mat-error>{{ error }}</mat-error>
    }
  </div>
</div>

<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="form?.invalid || isLoading">Gem ændring</button>
  <button [mat-dialog-close] mat-raised-button class="modal-cancel">Fortryd</button>
</div>
